/**
 * AppRoot Component
 *
 * Main routing component for Flux DC.
 * Registered in flux-web's app registry.
 */

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProjectsPage from './ProjectsPage';
import ProjectEditor from './ProjectEditor';
import { appConfig } from '../config/appConfig';

function AppRoot() {
  return (
    <Routes>
      <Route index element={<ProjectsPage />} />
      <Route path=":projectId" element={<ProjectEditor />} />
      <Route path="*" element={<Navigate to={appConfig.appPath} replace />} />
    </Routes>
  );
}

export default AppRoot;
